module.exports = __webpack_public_path__ + "static/20220306_114202-ac104093aafb4a4e251f5483b8c6ff8a.jpg";